import { useGetActivities, useGetAllTagsOfTagType } from 'api';
import { filterSideMenuTagsFromTags } from 'reporting/helpers';
import { DAY_CODE_TAG_TYPE } from 'shared';

export const useFetchTags = () => {
    const { data: tags } = useGetAllTagsOfTagType(DAY_CODE_TAG_TYPE);
    const filterSideMenuDisplayTags = filterSideMenuTagsFromTags(tags, '');
    const activitiesList = useGetActivities();

    const flattenedResults = activitiesList.data?.pages.flatMap((page) => page);

    const updatedFilterSideMenuDisplayTags = filterSideMenuDisplayTags.map((tag) => {
        const isDisabled = !flattenedResults?.some((activity) =>
            activity?.tags?.some((activityTag) => activityTag.name === tag.value),
        );
        return { ...tag, isDisabled };
    });

    return updatedFilterSideMenuDisplayTags;
};
